import { Box } from '@mui/material';
import * as Preact from 'preact';

export interface Props {
    logoUrl: string;
}

export const Component = (p: Props) => {
    return (
        <Box
            sx={{
                backgroundImage: `url(${p.logoUrl})`,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'left',
                height: '25px',
                width: 'auto',
            }}
        />
    );
};

Component.displayName = 'LoadingLogo';
